var $d4d5d8dab362555c$exports = {};
$d4d5d8dab362555c$exports = {
  "deselectedItem": function deselectedItem(args) {
    return "".concat(args.item, " ej markerat.");
  },
  "longPressToSelect": "Tryck l\xE4nge n\xE4r du vill \xF6ppna v\xE4ljarl\xE4ge.",
  "select": "Markera",
  "selectedAll": "Alla markerade objekt.",
  "selectedCount": function selectedCount(args, formatter) {
    return "".concat(formatter.plural(args.count, {
      "=0": "Inga markerade objekt",
      one: function one() {
        return "".concat(formatter.number(args.count), " markerat objekt");
      },
      other: function other() {
        return "".concat(formatter.number(args.count), " markerade objekt");
      }
    }), ".");
  },
  "selectedItem": function selectedItem(args) {
    return "".concat(args.item, " markerat.");
  }
};
export { $d4d5d8dab362555c$exports as default };